module.exports = __webpack_public_path__ + "static/media/dem_rem_con.d140a7b5.png";